import React from "react";
import { Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import Layout from "../layout/main";
import Home from "../pages/Home";
import LoginGuide from "../pages/Guide";
import Dashboard from "../pages/Dashboard";
//import NewDashboard from '../pages/NewDashboard';
import Welcome from "../pages/Welcome";
import Quiz from "../pages/Quiz";
import StartQuiz from "../pages/Quiz/start-quiz";
import ReviewQuiz from "../pages/Quiz/review-quiz";
import quizReviewFunctionality from "../pages/Quiz/quiz-review-functionality";

// import QuizHistory from "../pages/Quiz/quiz-history";
import Help_Faq from "../pages/Help_Faq";
// import Header from '../layout/main/Header';
import { showLoader, hideLoader } from "../action";
import FullPageLoader from "../components/Loader/FullPageLoader";
import ResetPassword from "../pages/Auth/ResetPassword";
import { IRootState } from "../interfaces";
import { IAppRoutesProps } from "../interfaces/appRoutes.interface";
import { AppRoutes } from "../config";
import Authenticated from "./Authenticated";
import NotFound from "../pages/404";
import TermsConditions from "../pages/TermsConditions";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import VerifiedToken from "../pages/Auth/VerifiedToken";
//Module routes
import Module from "../pages/Module";
import subModule from "../pages/Module/sub-module";
//video Routes
import Video from "../pages/Video";
import view_Video from "../pages/Video/view-video";

//Check in routes
import CheckIn from "../pages/CheckIn";

// Check in routes
import DailyCheckIn from "../pages/DailyCheckIn";

// Resources component

import Resources from "../pages/Resources";

export interface IDefaultComponentProps {
  component: any;
  layout: any;
  exact: boolean;
  path: string;
}

const DefaultLayout: React.FC<IDefaultComponentProps> = ({
  component: Component,
  layout: Layout,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout {...props}>
          <Component {...props} />
        </Layout>
      )}
    />
  );
};

const AppRoutesComponent: React.FC = (props: IAppRoutesProps) => {
  const { mainState } = props;
  return (
    <>
      {" "}
      {mainState && mainState.showLoader ? <FullPageLoader /> : null}
      <Switch>
        <Route exact path={"/"} layout={Layout} component={Home} />
        <Route exact path={"/login-guide"} component={LoginGuide} />
        <Route exact path={"/verify-user"} component={VerifiedToken} />
        <Route
          exact
          path={AppRoutes.RESET_PASSWORD}
          component={ResetPassword}
        />

        <DefaultLayout
          exact
          path={AppRoutes.MY_VIDEOS}
          layout={Layout}
          component={Video}
        />
        <DefaultLayout
          exact
          path={AppRoutes.MY_VIDEOS_VIEW}
          layout={Layout}
          component={view_Video}
        />
        <DefaultLayout
          exact
          path={AppRoutes.MY_MODULE}
          layout={Layout}
          component={Module}
        />

        <DefaultLayout
          exact
          path={AppRoutes.MY_SUB_MODULE}
          layout={Layout}
          component={subModule}
        />

        <Authenticated
          exact
          path={AppRoutes.MY_ACCOUNT}
          layout={Layout}
          component={Dashboard}
        />
        <Authenticated
          exact
          path={AppRoutes.WELCOME}
          layout={Layout}
          component={Welcome}
        />        
        <Authenticated
          exact
          path={AppRoutes.QUIZ}
          layout={Layout}
          component={Quiz}
        />
        <Authenticated
          exact
          path={AppRoutes.START_QUIZ}
          layout={Layout}
          component={StartQuiz}
        />
        <Authenticated
          exact
          path={AppRoutes.REVIEW_QUIZ}
          layout={Layout}
          component={ReviewQuiz}
        />
        <Authenticated
          exact
          path={AppRoutes.QUIZ_REVIEW_FUNCTIONALITY}
          layout={Layout}
          component={quizReviewFunctionality}
        />
        {/* <Authenticated
          exact
          path={AppRoutes.QUIZ_HISTORY}
          layout={Layout}
          component={QuizHistory}
        /> */}
        <Authenticated
          exact
          path={AppRoutes.HELP_FAQ}
          layout={Layout}
          component={Help_Faq}
        />

        <Authenticated
          exact
          path={AppRoutes.CHECK_IN}
          layout={Layout}
          component={CheckIn}
        />

        <Authenticated
          exact
          path={AppRoutes.RESOURCES}
          layout={Layout}
          component={Resources}
        />
         <Authenticated
          exact
          path={AppRoutes.DAILY_CHECK_IN}
          layout={Layout}
          component={DailyCheckIn}
        />
        {/*<Authenticated
          exact
          path={AppRoutes.NEW_DASHBOARD}
          layout={Layout}
          component={NewDashboard}
      />*/}
        <DefaultLayout exact path="/terms-conditions" layout={Layout} component={TermsConditions} />
        <DefaultLayout exact path="/privacy-policy" layout={Layout} component={PrivacyPolicy} />
        <DefaultLayout exact path="*" layout={Layout} component={NotFound} />
      </Switch>
    </>
  );
};

const mapStateToProps: any = (state: IRootState) => ({
  mainState: state.mainReducer,
});
const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    showLoader: () => {
      dispatch(showLoader());
    },
    hideLoader: () => {
      dispatch(hideLoader());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppRoutesComponent);
